import {qrcanvas, setCanvasModule} from 'qrcanvas';
import config from './config.js';

function num3(num){
	return Math.floor(num * 1000) / 1000;
}

function num2(num){
	return Math.floor(num * 100) / 100;
}
	
function getQRcode({text, src, success}){
	let img = new Image();
	img.crossOrigin = 'anonymous';
	img.src = src;
	img.onload = ()=>{
		const canvas = qrcanvas({
			// cellSize: 5,
			padding:10,
			correctLevel: 'H',
			data: text,
			logo:{ 
				image:img,
			},
		});
		success && success(canvas.toDataURL('image/jpeg'));
	}
	img.onerror = ()=>{
		const canvas = qrcanvas({
			// cellSize: 5,
			padding:10,
			correctLevel: 'H',
			data: text,
		});
		success && success(canvas.toDataURL('image/jpeg'));
	}
}

function getQueryString(){
	return location.hash.split('?')[1];
}

export {num2, num3, getQRcode, getQueryString};